export default [
    {
      path: '/admin/approval-requests',
      name: 'approval-request',
      meta: { requiresAuth: true },
      component: () => import('@/pages/hr/approval-request')
    }
  ]
  